import { render, staticRenderFns } from "./PointOfSale.vue?vue&type=template&id=17616e36&scoped=true&lang=pug&"
import script from "./PointOfSale.vue?vue&type=script&lang=js&"
export * from "./PointOfSale.vue?vue&type=script&lang=js&"
import style0 from "./PointOfSale.vue?vue&type=style&index=0&id=17616e36&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17616e36",
  null
  
)

/* custom blocks */
import block0 from "./PointOfSale.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports